import { Link } from '@tanstack/react-router';
import type { Sport } from '@painpal/contracts';
import { Info } from 'lucide-react';
import type { SportFilter as Filter } from '../../api/keys';
import { SPORT_COLORS } from '../../theme/tokens';
import { COMBINED_NOTE, filterLabel, filterOptions, fitnessSearch, phoneNote } from './sportFilterModel';
import styles from './sportFilter.module.css';

interface SportFilterProps { sport: Filter; sports: readonly Sport[] }

export function SportFilter({ sport, sports }: SportFilterProps) {
  return (
    <div className={styles.scroll}>
      <nav className={styles.filter} aria-label="Sport filter">
        {/* Exact: ALL's empty search is a subset of every search, so Link would mark it current too. */}
        {filterOptions(sports).map((option) => (
          <Link
            key={option} to="/" search={fitnessSearch(option)} className={styles.option} activeOptions={{ exact: true }}
            aria-current={option === sport ? 'page' : undefined}
          >
            {option !== 'all' && <span className={styles.swatch} style={{ background: SPORT_COLORS[option] }} aria-hidden="true" />}
            {filterLabel(option)}
          </Link>
        ))}
      </nav>
    </div>
  );
}

// Desktop sits it inside the chart panel; phone puts it above the panel with the longer note.
export function SportFilterRow({ sport, sports, phone }: SportFilterProps & { phone: boolean }) {
  return (
    <div className={styles.row}>
      <SportFilter sport={sport} sports={sports} />
      {sport !== 'all' && <p className={styles.note}><Info size={12} aria-hidden="true" />{phone ? phoneNote(sport) : COMBINED_NOTE}</p>}
    </div>
  );
}
